import {useResizeObserver} from '@wojtekmaj/react-hooks';
import {Document, Page, pdfjs} from 'react-pdf';
import {useCallback, useEffect, useRef, useState} from "react";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import {getFileUrl} from "../../../../utils/consts";
import {Spinner} from "../../../shared";
import './file-viewer-content.css'
import {isMediumScreen, isMobileDevice, isSmallMediumScreen, isSmallScreen} from "../../../../utils/utils";

pdfjs.GlobalWorkerOptions.workerSrc = "https://torresowo.myftp.org/js/pdf.worker.min-GB3t0DcA.mjs"

const options = {
    cMapUrl: '/cmaps/',
    standardFontDataUrl: '/standard_fonts/',
};

const resizeObserverOptions = {};

const FileViewerPdf = ({file}) => {

    const [numPages, setNumPages] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [containerRef, setContainerRef] = useState(null);
    const [containerWidth, setContainerWidth] = useState(0);
    const [showPage, setShowPage] = useState(true);
    const [finishLoading, setFinishLoading] = useState(false);
    const hidePageTimeout = useRef(null);
    const [paddingSize, setPaddingSize] = useState(30);
    const [fileUrl, setFileUrl] = useState(getFileUrl(file));

    const calculatePadding = () => {

        let padding = 60;
        if (isSmallScreen()) {
            padding = 0;
        } else if (isSmallMediumScreen()) {
            padding = 10;
        } else if (isMediumScreen()) {
            padding = 15
        } else if (isMobileDevice()) {
            padding = 20;
        }
        setPaddingSize(padding);

        return padding;
    }

    const onResize = useCallback((entries) => {
        const [entry] = entries;

        const padding = calculatePadding();

        if (entry) {
            setContainerWidth(entry.contentRect.width - (padding * 2));
        }
    }, []);

    useResizeObserver(containerRef, resizeObserverOptions, onResize);

    useEffect(() => {
        calculatePadding();
    }, [])

    function onDocumentLoadSuccess({numPages: nextNumPages}) {
        setNumPages(nextNumPages);
    }

    useEffect(() => {
        setShowPage(true);
        setFinishLoading(false);
        if (fileUrl) {
            setTimeout(() => {
                setFinishLoading(true);
            }, 500);
        }
    }, [fileUrl])

    useEffect(() => {
        if (getFileUrl(file) !== fileUrl) {
            setFileUrl(getFileUrl(file));
        }
    }, [file, fileUrl]);

    const handleScroll = () => {
        if (!containerRef?.firstChild) return;

        const pages = [...containerRef.firstChild.children];
        const scrollPosition = containerRef.scrollTop;

        let closestPage = 1;
        let minOffset = Number.MAX_VALUE;

        pages.forEach((page, index) => {
            const offset = Math.abs((page.offsetTop - 120) - scrollPosition);
            if (offset < minOffset) {
                minOffset = offset;
                closestPage = index + 1;
            }
        });

        setShowPage(true);
        setCurrentPage(closestPage);
        if (hidePageTimeout.current) clearTimeout(hidePageTimeout.current);
        hidePageTimeout.current = setTimeout(() => {
            setShowPage(false);
            hidePageTimeout.current = null;
        }, 800);
    };

    return (
        <div
            style={{
                width: "100%",
                padding: `0 ${paddingSize}px`,
                height: "calc(100% - 20px)",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "7px",
                borderTopLeftRadius: "0",
                borderTopRightRadius: "0",
                overflow: "auto",
            }}
            ref={setContainerRef}
            onScroll={handleScroll}  // <- Detecta el scroll
        >
            {fileUrl &&
                <Document file={fileUrl} onLoadSuccess={onDocumentLoadSuccess} options={options}
                          loading={
                              <div className="file-viewer-content__pdf__spinner">
                                  <Spinner/>
                              </div>
                          }
                          className="file-viewer-content__pdf">
                    {finishLoading ?
                        Array.from(new Array(numPages), (_, index) => {
                            const pageNumber = index + 1;
                            return (
                                <Page
                                    className={"file-viewer-content__pdf__pdf-page"}
                                    key={`page_${pageNumber}`}
                                    pageNumber={pageNumber}
                                    width={containerWidth}
                                />
                            );
                        }) :
                        <div className="file-viewer-content__pdf__spinner">
                            <Spinner/>
                        </div>}
                </Document>}
            <div className="current-page-indicator" style={{
                paddingTop: "5px",
                paddingBottom: "5px",
                borderRadius: "5px",
                width: "130px",
                backgroundColor: "rgba(0,0,0,0.8)",
                zIndex: 3,
                textAlign: "center",
                color: "white",
                position: "absolute",
                bottom: "50px",
                left: "calc(50% - 65px)",
                opacity: (numPages && showPage) ? 1 : 0,
                transition: "opacity 0.5s",
            }}>
                Página {currentPage} de {numPages}
            </div>
        </div>
    );
};


export default FileViewerPdf;
